"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFavicon = void 0;
var getFavicon = function () {
    var _a;
    var favicon = (_a = document.querySelector("link[rel*='icon']")) === null || _a === void 0 ? void 0 : _a.getAttribute('href');
    if (favicon) {
        try {
            new URL(favicon);
        }
        catch (e) {
            favicon = window.location.origin + favicon;
        }
    }
    return favicon;
};
exports.getFavicon = getFavicon;
